import { useFeatureFlagEnabled, useFeatureFlagPayload } from 'posthog-js/react';

export const useFeatureFlag = (flagKey: string): boolean | string | undefined => {
  const isEnabled = useFeatureFlagEnabled(flagKey);
  const payload = useFeatureFlagPayload(flagKey);

  if (payload !== undefined && typeof payload === 'string') {
    return payload;
  }

  return isEnabled;
};
